export { FooterInput } from "./Input";
